module.exports = __webpack_public_path__ + "static/media/sentence-decoder.2afd763b.png";